import { useLogout } from '@frontend/features/authentication/lib/hook'
import { cn } from '@nextui-org/react'
import useAuth from '@scripts/frontend/hooks/useAuth'
import { useConfirmationDialog } from '@shared/features/confirm-modal/ConfirmationDialog'
import toast from 'react-hot-toast'

import MenuItem from './MenuItem'

const menuItems = [
  {
    title: 'Personal Information',
    to: '/my-account/edit-account',
  },
  {
    title: 'Order History',
    to: '/my-account/orders',
  },
  // {
  //     title: 'Coupons',
  //     to: '/my-account/coupons',
  // },
  // {
  //     title: 'Points',
  //     to: '/my-account/points-and-rewards',
  // },
  // {
  //     title: 'Shipping Addresses',
  //     to: '/my-account/edit-address',
  // },
  // {
  //     title: 'Billing Addresses',
  //     to: '/my-account/edit-address',
  // },
]

export function SideBarMenu() {
  const { getConfirmation } = useConfirmationDialog()
  const { user } = useAuth()
  const { mutate } = useLogout()

  async function handleLogout() {
    const confirmed = await getConfirmation({
      body: `Are you sure you want to logout?`,
      confirmButtonProps: {
        color: 'primary',
      },
      confirmText: 'Logout',
      dismissButtonProps: {
        color: 'default',
      },
      dismissText: 'Cancel',
      header: 'Logout Confirmation!',
    })

    if (!confirmed) {
      return
    }

    await toast
      .promise(mutate(null), {
        error: (error) => error?.message || 'Failed to logout',
        loading: 'Logging out...',
        success: 'Logged out successfully',
      })
      .then(() => (window.location.href = '/'))
  }

  return (
    <div
      className={cn(
        'relative hidden w-[270px] flex-shrink-0 bg-[#f7f8fa] p-8 md:block',
      )}
    >
      <span className="mb-10 block font-medium uppercase">
        Howdy!, {user?.displayName}
      </span>
      <nav className="main-navigation">
        <ul className="divide-y">
          {menuItems.map((item, index) => (
            <li key={index}>
              <MenuItem title={item.title} to={item.to} />
            </li>
          ))}
          <li>
            <MenuItem onPress={handleLogout} title="Logout" />
          </li>
        </ul>
      </nav>
    </div>
  )
}

export default SideBarMenu
